import React from 'react';
import ImageGallerrationlit from '../components/ImageGallerrationlit';
import IRCTVDonationCard from "./IRCTVDonationCard";


const IRCRATION = () => {
    const helplineBaseAmount = 1200;
    return (
        <>
            <div className="about-us-container">
                {/* Detailed Activities Section */}
                <section className="activities-details">
                    <button
                        onClick={() => window.history.back()}
                        style={{
                            marginBottom: '10px',
                            padding: '8px 10px',
                            backgroundColor: '#255fe8',
                            color: 'white',
                            border: 'none',
                            borderRadius: '5px',
                            cursor: 'pointer',
                            fontSize: '16px',
                            display: 'flex',
                            alignItems: 'center',
                        }}
                    >
                        ← Back to All Activities
                    </button>
                    <div className="activity-intro">
                        <h2>OUR ACTIVITIES</h2>
                        <p>
                            All praise and thanks are due to Allaah Subhaanahu wa Ta'ala, IRC - Islamic Research Centre Education & Welfare Trust is involved in the following Social, Welfare and Charitable activities
                        </p>
                    </div>


                    <ImageGallerrationlit />

                    {/* Ration Kits & Food Distribution */}
                    <div className="activity-card">
                        <div className="activity-header">
                            <h3>RATION KITS & FOOD DISTRIBUTION</h3>
                        </div>
                        <div className="activity-content">
                            <p>
                                Ration kits containing food grains, oil, tea, and pulses are distributed on a monthly basis to the poor and needy, Alhamdulillaah.
                            </p>
                            <p>
                                During times of necessity, IRC also distributes food packets in slums, hospitals and other places. During the COVID-19 lockdown, IRC distributed food packets to more than 500 people every day for 3 months, Alhamdulillaah.
                            </p>
                        </div>
                        <IRCTVDonationCard
                            title="RATION KITS & FOOD DISTRIBUTION"
                            baseAmount={helplineBaseAmount}
                            subtitle="Your donation makes a difference"
                            description="Donate Us continue providing quality content and services to our community."
                            amount="₹5000"
                            purpose="Cause: DONATE US TO CONTINUE PROVIDING RATION KIT (15KG WHEAT, 2KG DAAL, 2LIT COOKING OIL, TEA MATERIALS, & MASALE)"
                        />
                    </div>
                </section>
            </div>
        </>
    );
};

export default IRCRATION;
